import { GetterTree, Module, MutationTree } from 'vuex'
import { MultiViewState, State } from '../types'
import { Token } from '@/utils/constants'
import { getCookieValue, setCookieValue } from '@/utils'

export enum MultiViewMutations {
    SET_SELECTED_MULTIDESK_TABLES = 'SET_SELECTED_MULTIDESK_TABLES'
}

function readPersistedJson<T>(key: string, fallback: T): T {
    const raw = getCookieValue(key)
    if (!raw) return fallback

    try {
        return raw.b64decode().toObject<T>()
    } catch {
        try {
            return raw.toObject<T>()
        } catch {
            setCookieValue(key, JSON.stringify(fallback).b64encode())
            return fallback
        }
    }
}

function loadPersistedSelectedTables(): number[] {
    const tables = readPersistedJson<number[]>(Token.MULTIBET_DESK, [])
    if (!Array.isArray(tables)) return []
    return tables
        .map(id => Number(id))
        .filter(id => Number.isFinite(id) && id > 0)
}

const state: MultiViewState = {
    selectedTables: loadPersistedSelectedTables()
}

const mutations: MutationTree<MultiViewState> = {
    [MultiViewMutations.SET_SELECTED_MULTIDESK_TABLES](
        moduleState,
        selectedTables: Array<number>
    ) {
        moduleState.selectedTables = selectedTables
        setCookieValue(
            Token.MULTIBET_DESK,
            JSON.stringify(selectedTables || []).b64encode()
        )
    }
}

const getters: GetterTree<MultiViewState, State> = {
    selectedTables(moduleState): Array<number> {
        return moduleState.selectedTables
    }
}

export const multiview: Module<MultiViewState, State> = {
    state,
    mutations,
    getters
}
